import { getOfferProduct, sendAnalytics } from 'shared/utils/analytics';

interface ITrackChatButtonClickParams {
  offerId: number;
  position: number;
  ownerId?: number;
  label?: string;
  houseId: number;
}

export const trackChatButtonClick = ({ offerId, position, ownerId, label, houseId }: ITrackChatButtonClickParams) =>
  sendAnalytics({
    category: 'card',
    action: 'send_message',
    label,
    products: [getOfferProduct(offerId, position)],
    page: {
      extra: {
        owner_id: ownerId,
        houseId,
      },
    },
  });
